import React, { useState } from 'react'
import {
    useNavigate,
    useParams,
    useSearchParams,
    useLocation,
} from 'react-router-dom'

import { Contract, ContractPosition, ContractPerformance } from '../../types'

import FooterLeftToolbarButtons from './Buttons/FooterLeftToolbarButtons'
import FooterRightToolbarButtons from './Buttons/FooterRightToolbarButtons'

type Props = {
    theme: string
    purchaseGuid: string | undefined
    purchaseStage: string

    user_guid: string | null
    pos_user_guid: string
    pos_supervisor_user_guid: string
    role: string

    stage: string
    status: string

    purchaseYear: string

    onUpdateContractFormEis: () => void
    isLoading: boolean
}

const Footer: React.FC<Props> = (props) => {
    const navigate = useNavigate()

    const handleClose = () => {
        if (props.stage) {
            navigate(
                `/hub/purchases?year=${props.purchaseYear}&stage=${encodeURIComponent('Реестр закупок')}` // Когда появятся все категории нужно будет вернуть props.stage
            )
        } else {
            navigate(`/hub/purchases?year=${props.purchaseYear}`)
        }
    }

    return (
        <footer className="flex flex-row w-full min-h-10 items-center justify-end ">
            <div className="flex flex-row gap-2 p-2 px-[22px] w-full h-full bg-[#d2d5d8] dark:bg-[#262427] items-center justify-start">
                <FooterLeftToolbarButtons
                    theme={props.theme}
                    purchaseStage={props.purchaseStage}
                    role={props.role}
                    isLoading={props.isLoading}
                    actions={{
                        update: props.onUpdateContractFormEis,
                    }}
                />
                <div className="flex flex-1"></div>
                <FooterRightToolbarButtons
                    theme={props.theme}
                    actions={{
                        close: handleClose,
                    }}
                />
            </div>
        </footer>
    )
}

export default Footer
